import React, { useEffect, useState } from 'react';
import { CancelButton, CreateButton, FilterButton, ImportButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation } from 'react-router-dom';
import SearchBar from '../../../../Components/Utils/SearchBar';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import ViewToggle from '../../../../Components/Utils/ViewToggle';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import { useFormik } from 'formik';
import * as yup from 'yup';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UseCatSubCatDropDown from '../../../../Components/Hooks/useCategoryDropDown';
import Importdoc from './Importdoc';
import ModalContainer from '../../../../Components/Others/ModalContainer';
import MultiEditItem from './MultiEditItem';
import axiosInstance from '../../../../Services/axiosCommon';
import { useToast } from '../../../../Components/Others/ToastServices';
import { GetAccess, GetRole, CheckEditAction, CheckDeleteAction } from '../../../../Components/Utils/roles';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import PremiumTable, { CopyButton } from '../../../../Components/Others/PremiumTable';
import { ViewButton, EditButton, DeleteButton } from '../../../../Components/Utils/ActionButtons ';

// Product Table Row Component
const ProductTableRow = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  setListofNumbers,
  setShowDelete,
}) => {
  return (
    <tr className="bg-white hover:bg-white/80 transition-colors align-middle">
      {/* Checkbox */}
      <td className="p-4 text-center align-middle border-t border-b border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onSelect}
          className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
        />
      </td>

      {/* Item Code */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 whitespace-nowrap">
        <div className="flex items-center text-sm font-semibold text-gray-800 gap-1">
          <span>{row.itemCode || "N/A"}</span>
          <CopyButton text={row.itemCode} />
        </div>
      </td>

      {/* Product Name */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 font-medium text-sm text-gray-800">
        <Link
          to={`/products/items/view/${row.productId}`}
          state={{ data: row, pageIndex, searchQuery }}
          className="hover:underline text-sm font-medium text-gray-800"
        >
          {row.productName || "N/A"}
        </Link>
      </td>

      {/* Category */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 whitespace-nowrap">
        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-100">
          {row.category || "N/A"}
        </span>
      </td>

      {/* Sub-Category */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-sm font-semibold text-gray-500 whitespace-nowrap">
        {row.subCategory || "N/A"}
      </td>

      {/* Action Buttons */}
      <td className="p-4 text-center align-middle border-t border-b border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
        <div className="flex items-center justify-center gap-1.5">
          {/* View */}
          <Link
            to={`/products/items/view/${row.productId}`}
            state={{ data: row, pageIndex, searchQuery }}
            className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
            title="View details"
          >
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </Link>
          {/* Edit */}
          {CheckEditAction(row, "Product Items", canEdit) && (
            <Link
              to={`/products/items/edit/${row.productId}`}
              state={{ data: row, from: "/products/items", pageIndex, searchQuery }}
              className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="Edit item"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </Link>
          )}
          {/* Delete */}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => {
                setListofNumbers([row.productId]);
                setShowDelete(true);
              }}
              className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="Delete item"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          )}
        </div>
      </td>
    </tr>
  );
};

// Product Card Component
const ProductCard = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  setListofNumbers,
  setShowDelete,
}) => {
  return (
    <div className="relative border border-y-gray-200/50 border-r-gray-200/50 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-4 flex flex-col gap-3.5 overflow-hidden border-l-4 border-l-[#048178]">
      {/* Card Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start gap-3 w-full min-w-0">
        <div className="flex items-center gap-2.5 flex-1 min-w-0 w-full overflow-hidden">
          {/* Checkbox */}
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-[#048178] focus:ring-[#048178] h-4 w-4 cursor-pointer shrink-0"
          />
          <div className="flex flex-col min-w-0 flex-1 w-full overflow-hidden">
            <Link
              to={`/products/items/view/${row.productId}`}
              state={{ data: row, pageIndex, searchQuery }}
              className="text-gray-800 font-semibold hover:underline text-sm truncate block w-full"
              title={row.productName}
            >
              {row.productName || "N/A"}
            </Link>
            <div className="flex items-center text-xs font-semibold text-[#048178] mt-0.5 min-w-0">
              <span className="truncate block  min-w-0">{row.itemCode || "N/A"}</span>
              <CopyButton text={row.itemCode} />
            </div>
          </div>
        </div>

        {/* Category tag */}
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-[#E6F2F2] text-[#048178] border border-[#048178]/20 shrink-0">
          {row.category || "N/A"}
        </span>
      </div>

      {/* Middle Grid */}
      <div className="bg-[#FAFAFC]/80 rounded-xl p-3 border border-gray-100 flex flex-wrap sm:flex-nowrap justify-between items-center gap-2 text-xs">
        <div className="flex flex-col gap-0.5 flex-1 min-w-[90px]">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Sub-Category</span>
          <span className="font-bold text-gray-700 truncate">{row.subCategory || "--"}</span>
        </div>
        <div className="hidden sm:block w-[1px] h-7 bg-gray-200/60" />
        <div className="flex flex-col gap-0.5 flex-1 min-w-[80px]">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Brand</span>
          <span className="font-bold text-gray-700 truncate">{row.brand || "--"}</span>
        </div>
        <div className="hidden sm:block w-[1px] h-7 bg-gray-200/60" />
        <div className="flex flex-col gap-0.5 flex-1 min-w-[60px]">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Unit</span>
          <span className="font-bold text-gray-700 truncate">{row.unit || "--"}</span>
        </div>
      </div>

      {/* Brand details and manufacturer */}
      {row.manufaturer && (
        <div className="text-[11px] text-gray-500 font-medium px-1 flex justify-between items-center">
          <span>Manufacturer:</span>
          <span className="font-bold text-gray-700 truncate ml-2">{row.manufaturer}</span>
        </div>
      )}

      {/* Action Buttons Row */}
      <div className="flex flex-wrap sm:flex-nowrap items-center justify-between gap-2 border-t border-gray-100 pt-3 mt-0.5">
        <ViewButton
          viewLink={`/products/items/view/${row.productId}`}
          viewState={{ data: row, pageIndex, searchQuery }}
        />
        <div className="flex gap-2 flex-1 sm:flex-none justify-end">
          {CheckEditAction(row, "Product Items", canEdit) && (
            <EditButton
              editLink={`/products/items/edit/${row.productId}`}
              editState={{ data: row, from: "/products/items", pageIndex, searchQuery }}
            />
          )}
          {CheckDeleteAction(row, canDelete) && (
            <DeleteButton
              onDelete={() => {
                setListofNumbers([row.productId]);
                setShowDelete(true);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

function ItemIndex() {
  const toast = useToast();
  const location = useLocation();
  const currentPage = location.state?.currentPage
  const searchQuery = location.state?.searchQuery
  const [page, setPage] = useState(currentPage || 1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20)
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [viewMode, setViewMode] = useState(localStorage.getItem("itemsViewMode") || "table");
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobileScreen ? "card" : viewMode;

  const { value: brand } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'brand_item', showFilterDialog)
  const { value: Manufacture } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Manufacture_item', showFilterDialog)
  const { value: Unit } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Unit_item', showFilterDialog)

  const [filterProps, setFilterProps] = useState({
    category: "",
    subCategory: "",
    brand: "",
    manufacturer: "",
    underPromotion: "",
    unit: ""
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",
    category: "",
    subCategory: "",
    brand: "",
    manufacturer: "",
    underPromotion: "",
    unit: ""
  });
  const clearFilter = () => {
    setParams({
      ...params, category: "",
      subCategory: "",
      brand: "",
      manufacturer: "",
      underPromotion: "",
      unit: ""
    })
    formik.values.category = ""
    formik.values.subCategory = ""
    formik.values.brand = ""
    formik.values.manufacturer = ""
    formik.values.underPromotion = ""
    formik.values.unit = ""


    setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      category: yup.string(),
      subCategory: yup.string(),
      brand: yup.string(),
      manufacturer: yup.string(),
      underPromotion: yup.string(),
      unit: yup.string()
    }),
    onSubmit: (values) => {
      setParams({ ...params, ...values, page: 1 });
      setPage(1);
      setShowFilterDialog(false);
      setFilter(true);
    }
  })

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch('/items/', params);
  const defaultHeader = [
    // {
    //   title: "ID",
    //   width: "5%",

    //   field: "productId",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Item Code",
      width: "10%",
      isLink: true,
      id: "productId",
      link: '/products/items/view/',

      field: "itemCode",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Product",
      isLink: true,
      id: "productId",
      link: '/products/items/view/',
      width: "15%",
      field: "productName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Category",
      width: "10%",
      field: "category",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Sub-Category",
      width: "10%",
      field: "subCategory",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Unit",
    //   width: "5%",
    //   field: "unit",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "productId",
        removeValue: "productName",
        url: `/items/`,
        moduleName: "Items",
        from: `/products/items`,
        editLink: "/products/items/edit/",
        viewLink: "/products/items/view/"

      }
    },
  ];
  const availableHeaders = [
    {
      title: "ID",
      width: "5%",
      field: "productId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Item Code",
      width: "10%",
      isLink: true,
      id: "productId",
      link: '/products/items/view/',

      field: "itemCode",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Product",
      isLink: true,
      id: "productId",
      link: '/products/items/view/',
      width: "15%",
      field: "productName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Category",
      width: "10%",
      field: "category",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Sub-Category",
      width: "10%",
      field: "subCategory",
      textAlign: "center",
      rowAlign: "center",
    },

    // {
    //   title: "Under Promotion",
    //   width: "10%",
    //   field: "isPromotable",
    //   isCondition: true,
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Unit",
      width: "5%",
      field: "unit",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Manufaturer",
      width: "10%",
      field: "manufaturer",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Brand",
      width: "10%",
      field: "brand",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "HS Code",
      width: "10%",
      field: "hsCode",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Comments",
    //   width: "10%",
    //   field: "comments",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    // {
    //   title: "Product Description",
    //   width: "10%",
    //   field: "productDescription",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "productId",
        removeValue: "productName",
        url: `/items/`,
        moduleName: "Items",
        from: `/products/items`,
        editLink: "/products/items/edit/",
        viewLink: "/products/items/view/"
      }
    },
  ];

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount })
  }, [page, pageCount])

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  const { category: itemsCategory, subCategory: itemsSubCategory } = UseCatSubCatDropDown('/category/ItemCategory', "ItemCategory", formik?.values?.category);
  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };


  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some(Item => Item === value)) {
      NewId = listofNumbers.filter(Temp => Temp !== value);
      setListofNumbers(NewId)
    } else {
      setListofNumbers([...listofNumbers, value])
    }
  }

  const selectMultipleFunction = (e) => {
    console.log(e.target.checked);
    if (e.target.checked) {
      setListofNumbers(fullList)
    } else {
      setListofNumbers([])
    }

  }

  const handleMultiDelete = (data) => {
    axiosInstance.delete(`items/multi-delete`, {
      headers: {
        'Content-Type': 'application/json',
      },
      data: { "ids": data },
    })
      .then(res => {
        if (res.data?.status === true) {
          if (res?.data?.not_deleted_ids.length <= 0) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Deleted Successfully."
            });
            getData();
            setShowDelete(false)
          } else {
            toast.open({
              type: "warning",
              message: "Success",
              description: `${res.data?.msg} \n Some Products has dependenies` || "Deleted Successfully."
            });
            getData();
            setShowDelete(false)
          }

        } else if (res.data?.status === false && res.data?.error) {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Delete UnSuccessfull"
          });
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: res.data?.msg || "Warning."
          });
        }
      })
      .catch(err => {
        console.error(err);
        toast.open({
          type: "error",
          message: "Error",
          description: "Network Error."
        });
      });
  }

  useEffect(() => {
    let tempArr = []
    data && data.forEach(i => {
      console.log("I", i?.productId);
      tempArr.push(i?.productId)
    });
    setFullList(tempArr)
  }, [data])
  const canEdit = GetAccess("items_edit") || GetRole();
  const canDelete = GetAccess("items_delete") || GetRole();

  return (
    <div className='w-full h-full px-2 sm:px-4 py-2'>
      <div className='w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3'>
        <div className='w-full md:w-auto flex justify-between items-center gap-2'>
          <Breadcrumb
            items={[
              { name: "Product" },
            ]} />
          <div className='flex md:hidden items-center gap-2'>
            {GetRole() && <ImportButton handleClick={handleImportClick} />}
            {GetAccess("items_create") && <Link to="/products/items/create"><CreateButton label='Product' /></Link>}
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
          </div>
        </div>

        <div className='w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2'>
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1)
              }}
              value={params.search}
            />
          </div>
          <div className='hidden md:flex items-center gap-2'>
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
          </div>

          {/* Table / Card View Toggle */}
          <ViewToggle viewMode={effectiveViewMode} onViewChange={(mode) => setViewMode(mode)} />

          <div className='hidden md:flex items-center gap-2'>
            {GetRole() && <ImportButton handleClick={handleImportClick} />}
            {GetAccess("items_create") && <Link to="/products/items/create"><CreateButton label='Product' /></Link>}
          </div>
        </div>
      </div>
      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={effectiveViewMode}
        headers={[
          { title: "Item Code", width: "160px" },
          { title: "Product", width: "auto" },
          { title: "Category", width: "130px" },
          { title: "Sub-Category", width: "160px" },
          { title: "Action", align: "center", width: "110px" }
        ]}
        renderRow={(row, idx) => (
          <ProductTableRow
            row={row}
            isSelected={listofNumbers.includes(row.productId)}
            onSelect={() => selectOneFunction(row.productId)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            setListofNumbers={setListofNumbers}
            setShowDelete={setShowDelete}
          />
        )}
        renderCard={(row, idx) => (
          <ProductCard
            row={row}
            isSelected={listofNumbers.includes(row.productId)}
            onSelect={() => selectOneFunction(row.productId)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            setListofNumbers={setListofNumbers}
            setShowDelete={setShowDelete}
          />
        )}
        dataLoading={dataLoading}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        multiEditLabel="Multi Edit"
      />
      {showFilterDialog && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-[92vw] sm:w-[500px] md:w-[600px] max-w-full max-h-[85vh] bg-white p-5 sm:p-6 rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
            <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
              <h2 className="text-lg font-bold text-gray-800">Filter Product</h2>
              <button
                onClick={closeFilterDialog}
                type="button"
                className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={formik.handleSubmit} className="flex flex-col gap-2">
              <div className="flex flex-col sm:flex-row flex-wrap -mx-2">
                <FormikSelectTwo
                  label="Category"
                  placeholder="Choose"
                  Options={itemsCategory}
                  formik={formik}
                  name="category"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Sub-Category"
                  placeholder="Sub-Category"
                  Options={itemsSubCategory}
                  formik={formik}
                  name="subCategory"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Unit"
                  placeholder="Choose"
                  Options={Unit}
                  formik={formik}
                  name="unit"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Brand"
                  placeholder="Choose"
                  Options={brand}
                  formik={formik}
                  name="brand"
                  width="w-full sm:w-1/2"
                  px="2"
                />
              </div>

              <div className="flex justify-end gap-2.5 pt-4 mt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
      {showImportModal && (<Importdoc show={showImportModal} onClose={closeModal} getData={getData} />)}
      {showEdit && (<MultiEditItem data={listofNumbers} getData={getData} onClose={() => setShowEdit(false)} />)}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { handleMultiDelete(listofNumbers) }}
        closeModal={() => setShowDelete(false)}
      />
    </div>
  )
}

export default ItemIndex